import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SetNewValueObject } from '@vi-iot/client';

@Component({
  selector: 'app-vdd-enum-edit',
  templateUrl: './vdd-enum-edit.component.html',
  styleUrls: ['./vdd-enum-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddEnumEditComponent {
  @Input() matchedValue: any;
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();
  constructor() {}

  onEnumOptionChange(newValue: string): void {
    this.setNewValue.emit({
      path: this.matchedValue?.path,
      newValue,
    });
  }
}
